import { toast } from 'sonner';

import { logError } from '@/lib/errorLogging';

export const createShareNotify = (logContext: string, fallback: string) => ({
  notifyError: (message?: string, error?: unknown) => {
    logError(error, logContext);
    toast.error(message ?? fallback);
  },
  notifySuccess: (message: string) => toast.success(message),
});
